import React, { FC } from 'react'
import { connect } from 'react-redux'
import { Button } from 'antd'
import { createIText, createImageFormUrl, createRect } from '../../createNode'
const PLACEHOLDER_IMAGE_URL = 'https://baleen-cdn-g.bybieyang.com/lego/img/1620638360467.png'
interface NodeProps {
  instance: any
}

const Node: FC<NodeProps> = ({ instance }) => {
  const handlerCanvasAddNode = node => {
    instance?.setActiveObject(node)
    instance?.add(node)
  }
  const handleAddText = () => {
    handlerCanvasAddNode(createIText())
  }
  const handeAddImage = () => {
    createImageFormUrl(PLACEHOLDER_IMAGE_URL).then(image => {
      handlerCanvasAddNode(image)
    })
  }

  const handeAddRect = () => {
    handlerCanvasAddNode(createRect())
  }
  return (
    <div className="material-node">
      <Button size="small" onClick={handleAddText}>
        添加文字
      </Button>
      <Button size="small" onClick={handeAddImage}>
        添加图片
      </Button>
      <Button size="small" onClick={handeAddRect}>
        添加矩形
      </Button>
    </div>
  )
}

const mapStateToProps = state => ({
  instance: state.material.instance,
})

export default connect(mapStateToProps)(Node)
